<template>
  <div class="tree-item" style="margin-left: 20px;">
    <div style="background-color: white; padding: 5px;">
      <button v-if="item.children && item.children.length" @click="() => { this.showChildren = !this.showChildren}">
        <i v-if="!showChildren" class="fa fa-caret-right"></i>
        <i v-if="showChildren" class="fa fa-caret-down"></i>
      </button>
      {{ item.name }}
<!--        action buttons-->
      <button class="action-button" @click="makeRoot"><i class="fa fa-tree"></i></button>
      <button class="action-button" @click="() => {this.searching = !this.searching}"><i class="fa fa-truck-moving"></i></button>
      <button class="action-button" v-if="item.tag_id" @click="deleteNode"><i class="fa fa-trash"></i></button>
      <router-link class="action-button" :to="{ name: 'system.tags.node', params: { id: item.id }}"><i class="fa fa-user"></i></router-link>
      <div v-if="searching">
        <input v-model="searchString" @keypress.enter="searchNodes">
        <button @click="searchNodes"><i class="fa fa-search"></i></button>
        <div v-for="result in searchResults" :key="result.id">
          <div class="flex">
            <span style="font-size: 12px;" v-for="ancestor in result.ancestors" :key="ancestor.id">
              {{ ancestor.name }} >
            </span>
            {{ result.name }}
          </div>
          <button @click="() => { appendToNode(result.id, false) }"><i class="fa fa-mail-forward"></i></button>
          <button v-if="item.tag_id" @click="() => { appendToNode(result.id, true) }"><i class="fa fa-files-o"></i></button>
        </div>
      </div>
    </div>
    <template v-if="showChildren && item.children && item.children.length">
      <system-tag-tree-item @refreshTree="() => { $emit('refreshTree') }" @editing="() => { $emit('editing') }" v-for="child in item.children" :key="child.id" :item="child"></system-tag-tree-item>
    </template>
  </div>
</template>

<script>
import { http } from 'utils'
export default {
  name: 'system-tag-tree-item',
  props: {
    item: {
      required: true
    }
  },

  data () {
    return {
      searchResults: [],
      searchString: '',
      searching: false,
      showChildren: false
    }
  },

  methods: {
    makeRoot () {
      if (this.item.tag_id) {
        http.post(`/make-root/${this.item.id}`).then(() => {
          this.$emit('refreshTree')
        })
      } else {
        http.post(`/create-node/${this.item.id}`).then(() => {
          this.$emit('refreshTree')
        })
      }
      this.$emit('editing')
    },

    appendToNode (otherNodeId, duplicate) {
      if (this.item.tag_id) {
        http.post(`/append-to-node/${this.item.id}/${otherNodeId}`, { duplicate }).then(() => {
          this.$emit('refreshTree')
        })
      } else {
        http.post(`/create-node/${this.item.id}`, { parent_id: otherNodeId }).then(() => {
          this.$emit('refreshTree')
        })
      }
      this.$emit('editing')
    },

    deleteNode () {
      http.delete(`/delete-node/${this.item.id}`).then(() => {
        this.$emit('refreshTree')
      })
      this.$emit('editing')
    },

    searchNodes () {
      http.get(`/tag-nodes`, { params: { search: this.searchString } }).then(response => {
        this.searchResults = response.data.data
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tree-item {
  button {
    background: none;
    border: none;
    width: 20px;
  }
  .action-button {
    color: var(--brand-primary);
    &:hover {
      color: var(--brand-primary-dark);
    }
  }
}
</style>
